import * as React from 'react'
import * as _ from "lodash"
import moment from 'moment'
import { useSelector } from 'react-redux'
import Estimate from '../Estimate/Estimate'
import { isAgreedEstimate } from '../Estimate/EstimateUtils'
import { JobMode } from '../../Job'
import { copyObject } from '../../../../../utils'
import { CompanyT } from '../../../../../types/Company'
import {  AxiosInstance } from '../../../../../utils/RequestMethods'

import config from '../../../../../constants/config'
import { getVariableValue, VariableDocumentT, setValueVariables } from '../DocumentVariables'
import ButtonLoading from '../../../../../components/ButtonLoading/ButtonLoading'
import { ClientAgreementT } from './ClientAgreement'

import ListAgreements from '../ListAgreements'
import { AgreementT, JobT } from '../../../../../types/Job'
import { phoneFormat, formatPhoneNumberUS } from '../../../../../utils'
import { removePrefixUS } from '../../../../../utils/utilsT'
import { IAppState } from '../../../../../redux/reducers'

// END - Dummy variables

interface ClientAgreementProps {

  company: CompanyT
  job: JobT
  jobOrigin: JobT
  jobMode: JobMode
  nextDocument(): void
  refreshJob(newJob: JobT): void
  saveJob(): Promise<JobT>
  updateJob(key: string, value: any): void
  updateDocument(key: string, value: any): void

}

const clientAgreementObj: ClientAgreementT = {
  active: true,
  title: 'clientAgreement',
  state: 'all',
  name: 'clientAgreement',
  variables: [
    {
      key: "estimate",
      type: "array",
      value: [],
    }
  ]
  ,
  defaultAgreement: {
    type: 'agreement',
    clause: 'I Agreed.',
    content: null,
    timestamp: null,
    ip: null,
    userAgent: null,
  },
  agreement: []
}


const liStyle: React.CSSProperties = {
  marginBottom: 20
}


const getAgreementsCA = (job: JobT): Array<AgreementT> => {
  const agreements = job.documents.clientAgreement && job.documents.clientAgreement.agreement ? job.documents.clientAgreement.agreement : []
  return agreements;
}

const isAgreedCCA = (job: JobT, content: any) => {
  const agreements = job.documents.clientAgreement && job.documents.clientAgreement.agreement ? job.documents.clientAgreement.agreement : []
  if (_.isArray(agreements) && agreements.length > 0) {
    const findItem = agreements.find((x) => _.isEqual(x.content, content))
    if (findItem) {
      return true;
    }
  }
  return false;
}


const ClientAgreementAll: React.FunctionComponent<ClientAgreementProps> = ({ company, job, jobOrigin, jobMode, nextDocument, refreshJob, saveJob, updateJob, updateDocument }): JSX.Element => {
  let auth = useSelector((state: IAppState) => state.auth)
  const [currentVariables, setCurrentVariables] = React.useState(clientAgreementObj.variables)
  const userRole = auth.userData && auth.userData.roles ? auth.userData.roles[0] : []

  React.useEffect(() => {
    // variables Current Document
    let variablesCD = job.documents.clientAgreement && job.documents.clientAgreement.variables
    let cloneVariables = copyObject(currentVariables)
    if (variablesCD && !_.isEqual(variablesCD, currentVariables)) {
      cloneVariables = copyObject(variablesCD)
      console.log("ClientAgreementAll->currentVariables->cloneVariables", cloneVariables)
    }
    // check estimate
    let estimateVariables = job.documents.estimate && job.documents.estimate.variables ? job.documents.estimate.variables : []
    const currentEstmaiteV = getVariableByKey('estiamte', cloneVariables);
    if (!_.isEqual(estimateVariables, currentEstmaiteV)) {
      cloneVariables = setValueVariables('estimate', estimateVariables, cloneVariables)
    }
    console.log("variablesCD", variablesCD)

    if (!_.isEqual(variablesCD, cloneVariables)) {

      updateDocumentVariables(copyObject(cloneVariables))
    }

    //  console.log("ClientAgreementAll->currentVariables", cloneVariables)
    setCurrentVariables(copyObject(cloneVariables))

  }, [job.documents.clientAgreement, job.documents.estimate])




  // render estimate
  const estimate = (): JSX.Element => {
    return (
      <div>
        <h3>Estimate</h3>
        <Estimate

          updateDocument={updateDocument}
          job={job}
          jobOrigin={jobOrigin}
          jobMode={jobMode}
          refreshJob={refreshJob}
          saveJob={saveJob}
          nextDocument={nextDocument}
          updateJob={updateJob} />
      </div>
    )
  }


  // getVariableByKey
  const getVariableByKey = (key: string, variables: Array<VariableDocumentT>): any => {
    return getVariableValue(key, variables)
  }


  const saveJobAndIAgree = async (): Promise<string> => {

    const fetchSaveIAgree = async () => {
      let res = await saveIAgree();
      if (res && res.data) {
        let data: JobT = res.data
        let msg = 'Client Agreement saved.'
        refreshJob(data)
        return msg;
      }

      return res
    }

    try {
      if (job.jobStatus == "inquiring") {
        let resSaveJob = await saveJob();
        if (resSaveJob) {
          return await fetchSaveIAgree()
        }else{
          throw new Error("save failed.")
        }
      } else {
        return await fetchSaveIAgree()
      }
    } catch (error) {
      //  console.log("error", error)
      throw error
    }
  }


  // iAgree
  let iAgree = async (): Promise<string> => {
    try {
      let res = await saveIAgree();
      if (res && res.data) {
        let data: JobT = res.data
        let msg = 'Client Agreement saved.'
        refreshJob(data)
        return msg;
      }
    } catch (error) {
      //  console.log("error", error)
      throw new Error(error);
    }
  }


  // isChangedCCA
  const isChangedCCA = (): boolean => {
    const currentCCA = job.documents.clientAgreement && job.documents.clientAgreement.variables
    const originCCA = jobOrigin.documents.clientAgreement && jobOrigin.documents.clientAgreement.variables
    const isChanged = !_.isEqual(originCCA, currentCCA)
    // console.log("isChanged", isChanged)
    return isChanged
  }

  const isChangeEstimate = (): boolean => {
    let cloneVariables = copyObject(currentVariables)
    let estiamteVariables = job.documents.estimate && job.documents.estimate.variables ? job.documents.estimate.variables : []
    const currentEstmaiteV = getVariableByKey('estiamte', cloneVariables);
    return !_.isEqual(estiamteVariables, currentEstmaiteV)
  }

  const getMailingAddress = () => {
    const { stateMeta } = job.companyInfo

    const samePrimaryPuc = stateMeta && stateMeta.Colorado && stateMeta.Colorado.pucAddress && !stateMeta.Colorado.samePrimaryPuc
    return samePrimaryPuc ? stateMeta.Colorado.pucAddress : job.companyInfo.address
  }
  // render parties
  const parties = (): JSX.Element => {
    const addressState = _.isArray(job.locations) && job.locations[0] && job.locations[0].addressState
    // const showMailingAddress = job.jobType != "moving_labor" ? true : false
    return (
      <div>
        <h3>Parties</h3>
        <p>
          This agreement (hereinafter "Agreement") is enacted between the Parties of:
        </p>
        <ol>
          <li key={0} style={liStyle}>
            <strong>{job.companyInfo.name}</strong>, (hereinafter "Company"), with information of
            <ul>
              <li key={0}>Phone: {removePrefixUS(formatPhoneNumberUS(job.companyInfo.phone))}</li>
              <li key={1}>Email: {job.companyInfo.email}</li>
              <li key={2}>Physical Address: {job.companyInfo.address} {job.companyInfo.addressTwo != null && <>Unit {job.companyInfo.addressTwo}</>}</li>
              {(addressState == 'Colorado' && job.jobType != "moving_labor") &&
                <>
                  <li key={3}>Mailing Address on file with PUC: {getMailingAddress()}</li>
                  <li key={4}>{job.companyInfo.name} is registered with the Public Utilities Commission of the State of Colorado as a mover. Permit No. {job.companyInfo.stateMeta && job.companyInfo.stateMeta.Colorado && job.companyInfo.stateMeta.Colorado.pucNumber}.</li>
                </>
              }
            </ul>
          </li>
          <li style={liStyle} key={1}>
            <strong>{job.client.firstName} {job.client.lastName}</strong>, (hereinafter "Shipper", "Client"), with information of
            <ul>
              {job.client.phone != '' && <li key={0}>
                Phone: {removePrefixUS(formatPhoneNumberUS(job.client.phone))}
              </li>}
              {job.client.email != '' && <li key={1}>
                Email: {job.client.email}
              </li>}
              {job.client.address != '' && <li key={2}>
                Address: {job.client.address}
                {job.client.address2 != '' && <>Unit: {job.client.address2}</>}
              </li>}
            </ul>
          </li>
        </ol>
      </div>
    )
  }

  // updateCurrentVariables
  const updateCurrentVariables = (key: string, value: any): void => {
    let cloneCurrentVariables = setValueVariables(key, value, currentVariables)
    setCurrentVariables(copyObject(cloneCurrentVariables))
    updateDocumentVariables(cloneCurrentVariables)
  }


  // updateDocumentVariables
  const updateDocumentVariables = (variables: Array<VariableDocumentT>): void => {
    let documentsClone = copyObject(job.documents)
    if (!documentsClone.clientAgreement) {
      documentsClone = { ...documentsClone, ...{ clientAgreement: copyObject(clientAgreementObj) } }
    } else {
      documentsClone.clientAgreement.variables = variables;
    }

    updateJob('documents', documentsClone)
  }

  const isNullClientAgreement = (newJob: JobT): boolean => {
    return newJob.documents.clientAgreement && newJob.documents.clientAgreement.variables ? false : true
  }


  //  saveClientAgreement
  const saveClientAgreement = async (): Promise<string> => {
    try {
      let data = await saveJob();
      if (data) {
        let msg = 'Client Agreement saved.'
        refreshJob(data)


        return msg;
      }
    } catch (error) {
      console.log("error", error)
      throw new Error(error);
    }
  }



  //  saveIAgree
  const saveIAgree = async (): Promise<any> => {
    let url = `${config.url.wpJson}/wp/v2/jobs/${job.id}/agreements`
    let params = {
      name: 'clientAgreement',
      type: 'agreement',
      clause: 'I Agreed.',
      content: currentVariables

    }
    return await AxiosInstance.post(url, params)
  }

  const setAgreementByContent = (variables: Array<VariableDocumentT>): void => {


    let documentsClone = copyObject(job.documents)
    let vEsitamte = getVariableByKey('estimate', variables)
    if (vEsitamte) {
      documentsClone.estimate.variables = vEsitamte
    }
    documentsClone.clientAgreement.variables = variables
    updateJob('documents', documentsClone)
  }


  return (
    <div>
      {userRole.includes('client') && <p>I, {job.client.firstName} {job.client.lastName}, agree to the terms laid out in this Client Agreement.</p>}
      {parties()}
      {estimate()}
      <p style={{ marginBottom: 10, marginTop: 5 }} >Client agrees to the payment above for the Moving and/or Moving-Related Services estimated in the Estimate above. In the case of damages, Client agrees to make payment in full for all goods and/or services rendered prior to informing a manager or company representative and initiating the Damages Assessment Process. Client agrees to a process of arbitration in the case of a dispute.</p>
      {(userRole.includes('administrator') || userRole.includes('manager')) && isAgreedEstimate(job) && isAgreedCCA(job, currentVariables) && !isChangedCCA() &&
        <p className="text-success text-left">{`Client,  ${job.client.firstName}  ${job.client.lastName}, has agreed to the terms laid out above.`}</p>}

      {/* {isAgreedEstimate(job) && (!isAgreedCCA(job, currentVariables) || isChangedCCA()) &&
                <ButtonLoading
                    disabled={isChangedCCA() || isNullClientAgreement(job) ? false : true}
                    className="btn-success"
                    onClickFetching={saveClientAgreement}>
                    Save Client Agreement
                 </ButtonLoading>
            } */}

      {jobMode == JobMode.Edit && (userRole.includes('administrator') || userRole.includes('manager')) && !isAgreedCCA(job, currentVariables) &&
        <div>
          <span className="text-danger">Client has not yet agreed to Client Agreement.</span>
        </div>
      }
      {jobMode == JobMode.Edit && userRole.includes('client') &&
        <>


          {(!isAgreedEstimate(job) || (isAgreedEstimate(job) && !isAgreedCCA(job, currentVariables))) &&
            <div><span style={{ fontWeight: "bold" }} className="text-danger">Agree to the terms above in order to schedule job.</span></div>
          }

          {(!isNullClientAgreement(job) && !isChangedCCA()) &&
            <ButtonLoading
              disabled={!isAgreedEstimate(job) || (isAgreedCCA(job, currentVariables) && !isChangedCCA())}
              className="btn-success"
              onClickFetching={saveJobAndIAgree}>
              {isAgreedCCA(job, currentVariables) && !isChangedCCA() ? `Agreed` : `I Agree`}
            </ButtonLoading>
          }
          <a id="anchor-agreement-clientAgreement" ></a>
        </>
      }
      <ListAgreements
        agreements={getAgreementsCA(job)}
        onClickView={(contant) => {
          setAgreementByContent(contant)
        }}
        currantContent={currentVariables}
      />
    </div>
  )
}

export default ClientAgreementAll;

